import "./skeleton.scss";

interface SkeletonLoaderProps {
  className?: string;
  height?: number;
  width?: number | string;
}

const SkeletonLoader = ({
  className,
  height = 20,
  width = "unset",
}: SkeletonLoaderProps) => {
  return (
    <div
      className={`skeleton-loader ${className ? className : "mt-1"}`}
      style={{ height: `${height}px`, width: `${width}px` }}
    />
  );
};

export default SkeletonLoader;
